import React from "react";
import { Box } from "@mui/material";
import { statusOfServices } from "constants/serviceDetails";

const GanttTaskContent = ({ data }) => {
	const isWorkOrder = !data.parent;
	const isService = data.parent && data.serviceData;

	if (isWorkOrder) {
		const workOrderText = data.workOrder || data.text || "";
		const interval = data.interval;
		
		let titleText = `Work Order: ${workOrderText}`;
		if (interval) titleText += `\nInterval: ${interval}`;
		if (data.estimatedMinutes) titleText += `\nEst. Time: ${data.estimatedMinutes} hrs`;
		
		return (
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					height: "100%",
					padding: "0 8px",
					color: "#fff",
					fontSize: "12px",
					fontWeight: 500,
					cursor: "pointer",
					width: "100%",
				}}
				title={titleText}
			>
				<span style={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}>
					{workOrderText}
				</span>
			</Box>
		);
	}

	if (isService) {
		const status = data.status || "S";
		const tasksSkipped = data.serviceData?.tasksSkipped || false;
		const statusName = statusOfServices(status, tasksSkipped);
		const role = data.serviceData?.role || "Role";
		const interval = data.interval;
		
		let titleText = `Status: ${statusName}\nRole: ${role}`;
		if (interval) titleText += `\nInterval: ${interval}`;
		if (data.estimatedMinutes) titleText += `\nEst. Time: ${data.estimatedMinutes} hrs`;
		if (data.progress !== undefined) titleText += `\nProgress: ${data.progress}%`;
		
		return (
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					height: "100%",
					padding: "0 8px",
					color: "#fff",
					fontSize: "12px",
					fontWeight: 500,
					cursor: "pointer",
					width: "100%",
				}}
				title={titleText}
			>
				<span style={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}>
					{role}
				</span>
			</Box>
		);
	}

	return <span>{data.text || ""}</span>;
};

export default GanttTaskContent;
